import { Navigate, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { useHasTool } from "../access/AccessProvider";
import { DASHBOARDS_INDEX_PATH, isDashboardsOnly } from "../dashboardsOnly";
import { getLazyToolComponent } from "../tools/registry";

function OperatorsToolRoute() {
  const hasOperators = useHasTool("operators");
  if (isDashboardsOnly()) {
    return <Navigate to={DASHBOARDS_INDEX_PATH} replace />;
  }
  if (!hasOperators) {
    return <Navigate to="/settings" replace />;
  }

  const OperatorsToolLayout = getLazyToolComponent("operators");
  if (!OperatorsToolLayout) {
    return <Navigate to="/settings" replace />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
          Loading Operators…
        </div>
      }
    >
      <OperatorsToolLayout />
    </Suspense>
  );
}

export const Route = createFileRoute("/_app/operators")({
  component: OperatorsToolRoute,
});
